import {Directive, ElementRef, Input} from '@angular/core';

@Directive({
  selector: '[scrollIntoView]'
})
export class ScrollIntoViewDirective {

  @Input() options: ScrollIntoViewOptions = { behavior: 'auto', inline: 'nearest', block: 'nearest' };

  @Input()
  set scrollIntoView(scroll: boolean) {
    if (scroll && this.elementRef.nativeElement) {
      this.elementRef.nativeElement.scrollIntoView(this.options);
    }
  }

  constructor(private elementRef: ElementRef) { }
}
